export const styles = (theme) => ({
    appBar: {
      background: "#fff",
      color: "#222",
      borderRadius: "12px 12px 0 0",
    },
    indicator: {
      backgroundColor: "transparent",
    }
  });